import {grid} from '~/design-system/foundations'
import {HgTextLink} from '~/design-system/hg/components'

export type Section = {
  title: string
  id: string
}

export const TOC_ID = 'table-of-contents'

type HgTableOfContentsProps = {
  sections: Section[]
}

export default function HgTableOfContents({sections}: HgTableOfContentsProps) {
  return (
    <nav
      aria-labelledby="toc-label"
      className={grid({className: 'm-auto scroll-mt-blog-navbars-height pt-s8'})}
      id={TOC_ID}
    >
      <div
        className={grid({
          className:
            'col-span-full gap-y-s5 border-t border-border-frosted pl-0 pr-0 pt-12 text-text-default md:col-span-8 md:col-start-3 lg:col-span-full',
        })}
      >
        <span
          id="toc-label"
          className="col-span-full w-full arcadia-ui-1 lg:col-span-4 lg:col-start-auto"
        >
          Table of Contents
        </span>
        <ol className="col-span-8 grid gap-s3">
          {sections.map((section, idx) => (
            <li key={idx}>
              <HgTextLink
                className="arcadia-ui-1"
                variant="revealUnderline"
                href={`#${section.id}`}
              >
                {section.title}
              </HgTextLink>
            </li>
          ))}
        </ol>
      </div>
    </nav>
  )
}
